import { render } from "./AposSpinner.vue?vue&type=template&id=e536a0aa&scoped=true"
import script from "./AposSpinner.vue?vue&type=script&lang=js"
export * from "./AposSpinner.vue?vue&type=script&lang=js"

import "./AposSpinner.vue?vue&type=style&index=0&id=e536a0aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e536a0aa"],['__file',"ui/ui/apos/components/AposSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e536a0aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e536a0aa', __exports__)) {
    api.reload('e536a0aa', __exports__)
  }
  
  module.hot.accept("./AposSpinner.vue?vue&type=template&id=e536a0aa&scoped=true", () => {
    api.rerender('e536a0aa', render)
  })

}


export default __exports__